// extracted by mini-css-extract-plugin
module.exports = {"ShopsNavigation":"styles_ShopsNavigation__N8C4Y","left":"styles_left__WjoU_","right":"styles_right__KwQ_E","link":"styles_link__nTfOG","active":"styles_active__qBq4L"};